// src/features/orders/components/OrderListSkeleton.tsx

interface OrderListSkeletonProps {
  rows?: number;
}

const PLACEHOLDER_CLASS = 'rounded bg-[var(--vania-colors-border-subtle,rgba(255,255,255,0.08))]';

export function OrderListSkeleton({ rows = 5 }: OrderListSkeletonProps) {
  return (
    <div className="divide-y divide-[var(--vania-colors-border-subtle,rgba(255,255,255,0.08))]">
      {Array.from({ length: rows }).map((_, index) => (
        <div key={index} className="flex animate-pulse items-center gap-3 px-5 py-3.5">
          <div className="min-w-0 flex-1 space-y-2">
            <div className={`h-3.5 w-32 ${PLACEHOLDER_CLASS}`} />
            <div className={`h-3 w-24 ${PLACEHOLDER_CLASS}`} />
          </div>
          <div className={`h-3 w-14 shrink-0 ${PLACEHOLDER_CLASS}`} />
          <div className={`h-3 w-16 shrink-0 ${PLACEHOLDER_CLASS}`} />
          <div className={`h-6 w-16 shrink-0 rounded-full ${PLACEHOLDER_CLASS}`} />
        </div>
      ))}
    </div>
  );
}
